<form [ngClass]="styles.searchWrapper">
	<vb-ui-search-input name="searchInput" [ngClass]="styles.search" ngModel [placeholder]="'Reports_Attendees_Column_SearchPlaceholder' | translate">
	</vb-ui-search-input>
</form>
<vb-ui-infinite-scroll-grid [ngClass]="styles.grid" [columnDefs]="columnDefs" [getRows]="getRows" [clearScrollId]="AnalyticsService.clearVideoScrollId" [pageSize]="pageSize" [quickFilterText]="searchText$ | async" [dataFetchContext]="dataFetchContext" (gridReady)="gridReady.emit($event)">
	<vb-ui-column-picker-group [headerName]="'Reports_Attendees_Column_Group_User' | translate" [id]="COLUMN_GROUP.USER" [isExpanded]="true">
	</vb-ui-column-picker-group>
	<vb-ui-column-picker-group [headerName]="'Reports_Column_Group_System' | translate" [id]="COLUMN_GROUP.SYSTEM">
	</vb-ui-column-picker-group>
	<vb-ui-column-picker-group [headerName]="'Reports_Column_Group_Session' | translate" [id]="COLUMN_GROUP.SESSION">
	</vb-ui-column-picker-group>
	<vb-ui-column-picker-group [headerName]="'Reports_Column_Group_Metrics' | translate" [id]="COLUMN_GROUP.METRICS" [disableColumnEntrySort]="true">
	</vb-ui-column-picker-group>
</vb-ui-infinite-scroll-grid>
